/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../app/components/payment/paymentRedirect.component';
const styles_PaymentRedirectComponent:any[] = ([] as any[]);
export const RenderType_PaymentRedirectComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_PaymentRedirectComponent,data:{}});
export function View_PaymentRedirectComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),
      (null as any));
}
export function View_PaymentRedirectComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'payment-redirect',
      ([] as any[]),(null as any),(null as any),(null as any),View_PaymentRedirectComponent_0,
      RenderType_PaymentRedirectComponent)),i0.ɵdid(49152,(null as any),0,i1.PaymentRedirectComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const PaymentRedirectComponentNgFactory:i0.ComponentFactory<i1.PaymentRedirectComponent> = i0.ɵccf('payment-redirect',
    i1.PaymentRedirectComponent,View_PaymentRedirectComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcGF5bWVudC9wYXltZW50UmVkaXJlY3QuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL3BheW1lbnQvcGF5bWVudFJlZGlyZWN0LmNvbXBvbmVudC50cyIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL3BheW1lbnQvcGF5bWVudFJlZGlyZWN0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcGF5bWVudC9wYXltZW50UmVkaXJlY3QuY29tcG9uZW50LnRzLlBheW1lbnRSZWRpcmVjdENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXY+PC9kaXY+IiwiPHBheW1lbnQtcmVkaXJlY3Q+PC9wYXltZW50LXJlZGlyZWN0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7Ozs7b0JDQUE7TUFBQTt5Q0FBQSxVQUFBO01BQUE7OzsifQ==



// WEBPACK FOOTER //
// ./compiled/app/components/payment/paymentRedirect.component.ngfactory.ts